import * as Yup from 'yup';

// Definindo o esquema de validação com Yup
export const validationSchema = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    emailTitle: Yup.string().required('Titulo é obrigatória'),
});